// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hzrsmwtpfpkidrdqnvbx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh6cnNtd3RwZnBraWRyZHFudmJ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA3MjkzMzYsImV4cCI6MjA1NjMwNTMzNn0.bQUXL2399dWeOp3M3W_E5xpUXtigaHOiHgjni9YktPc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);